import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AutomationModule } from '@frontend/sports/automation/core-feature';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { EffectsModule } from '@ngrx/effects';
import { RxFor } from '@rx-angular/template/for';
import { SGPBadgeComponent } from 'packages/sports/web/app/src/betbuilder/components/badge/sgp-badge/sgp-badge.component';
import { SGPPlusBadgeComponent } from 'packages/sports/web/app/src/betbuilder/components/badge/sgp-plus-badge/sgp-plus-badge.component';
import { ShowInEpcotDirective } from 'packages/sports/web/app/src/common/epcot-config.directive';
import { NumpadModule } from 'packages/sports/web/app/src/numpad/numpad.module';

import BetslipBaseModule from '../../base/betslip-base.module';
import { BetslipDigitalCommonModule } from '../common/digital-module';
import { InfoMessageContainerComponent } from '../info-messages/info-message-container/info-message-container.component';
import { LinearBetBuilderModule } from '../linear-bet-builder/linear-bet-builder.module';
import { LinearBetslipModule } from '../linear/linear-betslip-module';
import BetslipDigitalPicksModule from '../picks/betslip-digital-picks.module';
import PickOddsModule from '../picks/pick-odds.module';
import { DigitalRewardTokensModule } from '../reward-tokens/digital-reward-tokens.module';
import BetslipDigitalStakeModule from '../stake/betslip-digital-stake.module';
import BetslipDigitalSummaryModule from '../summary/betslip-digital-summary.module';
import BetslipDigitalValidationModule from '../validation/betslip-digital-validation.module';
import ComboBetBetbuilderInfoMessageComponent from './components/combo-bet-betbuilder-info-message.component';
import ComboBetHeaderComponent from './components/combo-bet-header.component';
import ComboBetPickComponent from './components/combo-bet-pick.component';
import ComboBetComponent from './components/combo-bet.component';
import ComboBetLinearComponent from './components/linear/combo-bet-linear.component';
import LinearBetBuilderComboContainerComponent from './components/linear/container/bet-builder/linear-bet-builder-combo-container.component';
import { LinearComboBetContainerErrorsComponent } from './components/linear/container/errors/linear-combo-bet-container-errors.component';
import LinearComboBetContainerComponent from './components/linear/container/linear-combo-bet-container.component';
import LinearComboBetBuilderDetailsComponent from './components/linear/container/main/details/linear-combo-bet-builder-details.component';
import LinearMainComboContainerComponent from './components/linear/container/main/linear-main-combo-container.component';
import { LinearBetBuilderComboListComponent } from './components/linear/linear-bet-builder-combo-list.component';
import ComboBetLinearEditToggleComponent from './components/linear/multi-toggle/combo-bet-linear-edit-toggle.component';
import LinearEffects from './effects/linear-effects';
import StakeEffects from './effects/stake-effects';
import { LinearComboModuleErrorViewModelService } from './services/linear/linear-combo-module-error-viewmodel.service';

@NgModule({
    imports: [
        CommonModule,
        BetslipBaseModule,
        BetslipDigitalPicksModule,
        EffectsModule.forFeature([StakeEffects, LinearEffects]),
        BetslipDigitalStakeModule,
        BetslipDigitalValidationModule,
        PickOddsModule,
        AutomationModule,
        NumpadModule,
        BetslipDigitalCommonModule,
        BetslipDigitalSummaryModule,
        DigitalRewardTokensModule,
        RxFor,
        LinearBetslipModule,
        LinearBetBuilderModule,
        ShowInEpcotDirective,
        InfoMessageContainerComponent,
        IconCustomComponent,
        SGPBadgeComponent,
        SGPPlusBadgeComponent,
    ],
    declarations: [
        ComboBetComponent,
        ComboBetPickComponent,
        ComboBetLinearComponent,
        ComboBetHeaderComponent,
        ComboBetBetbuilderInfoMessageComponent,
        ComboBetLinearEditToggleComponent,
        LinearComboBetBuilderDetailsComponent,
        LinearComboBetContainerComponent,
        LinearMainComboContainerComponent,
        LinearBetBuilderComboContainerComponent,
        LinearBetBuilderComboListComponent,
        LinearComboBetContainerErrorsComponent,
    ],
    exports: [ComboBetComponent, ComboBetLinearComponent, ComboBetBetbuilderInfoMessageComponent],
    providers: [LinearComboModuleErrorViewModelService],
})
export default class BetslipDigitalComboBetModule {}
